import { render, staticRenderFns } from "./EmailTemplateForm.vue?vue&type=template&id=1f430ec2&"
import script from "./EmailTemplateForm.vue?vue&type=script&lang=ts&"
export * from "./EmailTemplateForm.vue?vue&type=script&lang=ts&"
import style0 from "./EmailTemplateForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports